(function(window, document, $) {
    "use strict";

    var readDraftCookies = {
        init: function() {
            document.cookie = "irt=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"
        }
    }
    readDraftCookies.init();

})(window, document, jQuery);
